// The portal's frame — the header and sidebar, the small shared pickers (CheckboxDropdown, ListPicker), the bell,
// the decision dialog, the assistant bubble and the home dashboard — in the portal's four languages (2026-10-21).
// The rest of these components already read `nav.`, `notif.`, `ask.`, `pa.`, `home.` from i18n.js.
const en = {
  // Production menu entries that had no dictionary entry yet.
  styleHub: 'Style Hub',
  masterSheet: 'Master Sheet',
  productLine: 'Product Line',
  capacity: 'Capacity',
  sapShipDoc: 'SAP Ship Doc',
  dailyOutput: 'Daily Output',
  toggleNav: 'Toggle navigation',
  portalNav: 'Portal navigation',
  closeNav: 'Close navigation',
  testServer: 'Test server - port 3000, separate build and backend',
  roleSwitch: 'View the portal as one of your roles',
  // CheckboxDropdown
  all: 'All',
  searchIn: 'Search {{label}}',
  noMatches: 'No matches',
  done: 'Done',
  // ListPicker
  searchPh: 'Search…',
  clear: 'Clear',
  noMatchFor: 'No match for “{{q}}”',
  addToList: '+ Add “{{q}}” to the list',
  alreadyExists: '“{{name}}” already exists — use it',
  // The bell and the assistant, when a request fails with no message of its own
  failedStatus: 'Failed ({{status}})',
  chatScreenshot: '(screenshot)',
  // DecisionDialog
  close: 'Close',
  // HomeDashboard
  couldNotSave: 'Could not save',
  // the Christmas season (season.js, 31/10)
  xmasMenu: "Christmas",
  xmasOn: "Christmas look",
  xmasSnow: "Motion effects (snow, lights)",
  xmasNote: "Only for you, this season. The motion stops by itself if your device asks for less motion.",
  xmasGreeting: "Merry Christmas and a Happy New Year from HEVN!",
  xmasWish: "Wishing you and your family a warm and peaceful holiday season.",
  xmasHeroTitle: "Merry Christmas!",
  xmasToday: "Merry Christmas — today is the day!",
  xmasNewYear: "Happy New Year {{y}}!",
  xmasCountXmas: "{{n}} days to Christmas",
  xmasCountNY: "{{n}} days to the New Year",
  xmasTipTitle: "Christmas look is on 🎄",
  xmasTipBody: "Switch it off, or just the snow and lights, from this tree button. The record on Home's banner plays a Christmas tune.",
  xmasTipOff: "Switch Christmas off",
  xmasTipOk: "Got it",
  xmasMusicPlay: "Play a Christmas song",
  xmasMusicStop: "Stop \"{{title}}\"",
  xmasOffAsk: "Don't want the effects? Turn them off here. The 🎄 button at the top brings them back.",
  xmasMotionOff: "Turn off effects",
  xmasMotionOn: "Turn effects on",
};

const ko = {
  styleHub: '스타일 허브',
  masterSheet: '마스터 시트',
  productLine: '제품 라인',
  capacity: '생산 능력',
  sapShipDoc: 'SAP 선적 서류',
  dailyOutput: '일일 생산량',
  toggleNav: '메뉴 열기/닫기',
  portalNav: '포털 메뉴',
  closeNav: '메뉴 닫기',
  testServer: '테스트 서버 - 포트 3000, 별도 빌드와 백엔드',
  roleSwitch: '내 역할 중 하나로 포털 보기',
  all: '전체',
  searchIn: '{{label}} 검색',
  noMatches: '일치 항목 없음',
  done: '완료',
  searchPh: '검색…',
  clear: '지우기',
  noMatchFor: '“{{q}}”와 일치하는 항목 없음',
  addToList: '+ “{{q}}”를 목록에 추가',
  alreadyExists: '“{{name}}”이(가) 이미 있습니다 — 그 항목 사용',
  failedStatus: '실패 ({{status}})',
  chatScreenshot: '(스크린샷)',
  close: '닫기',
  couldNotSave: '저장하지 못했습니다',
  // the Christmas season (season.js, 31/10)
  xmasMenu: "크리스마스",
  xmasOn: "크리스마스 화면",
  xmasSnow: "움직이는 효과 (눈, 조명)",
  xmasNote: "이번 시즌, 나에게만 적용됩니다. 기기에서 움직임 줄이기를 켜면 효과는 자동으로 멈춥니다.",
  xmasGreeting: "HEVN이 즐거운 성탄절과 행복한 새해를 기원합니다!",
  xmasWish: "가족과 함께 따뜻하고 평안한 연말 보내세요.",
  xmasHeroTitle: "메리 크리스마스!",
  xmasToday: "메리 크리스마스 — 바로 오늘이에요!",
  xmasNewYear: "{{y}}년 새해 복 많이 받으세요!",
  xmasCountXmas: "크리스마스까지 {{n}}일",
  xmasCountNY: "새해까지 {{n}}일",
  xmasTipTitle: "크리스마스 화면이 켜져 있어요 🎄",
  xmasTipBody: "이 트리 버튼에서 끄거나, 눈과 조명만 끌 수 있어요. 홈 배너의 레코드를 누르면 캐럴이 나와요.",
  xmasTipOff: "크리스마스 끄기",
  xmasTipOk: "알겠어요",
  xmasMusicPlay: "캐럴 재생",
  xmasMusicStop: "\"{{title}}\" 정지",
  xmasOffAsk: "효과가 싫으신가요? 여기서 끌 수 있어요. 맨 위 🎄 버튼으로 다시 켤 수 있어요.",
  xmasMotionOff: "효과 끄기",
  xmasMotionOn: "효과 켜기",
};

const vi = {
  styleHub: 'Style Hub',
  masterSheet: 'Master Sheet',
  productLine: 'Dòng sản phẩm',
  capacity: 'Năng lực sản xuất',
  sapShipDoc: 'Chứng từ giao hàng SAP',
  dailyOutput: 'Sản lượng hằng ngày',
  toggleNav: 'Mở/đóng menu',
  portalNav: 'Menu portal',
  closeNav: 'Đóng menu',
  testServer: 'Máy chủ thử nghiệm - cổng 3000, bản build và backend riêng',
  roleSwitch: 'Xem portal theo một vai trò của bạn',
  all: 'Tất cả',
  searchIn: 'Tìm {{label}}',
  noMatches: 'Không có kết quả',
  done: 'Xong',
  searchPh: 'Tìm kiếm…',
  clear: 'Xóa',
  noMatchFor: 'Không có kết quả cho “{{q}}”',
  addToList: '+ Thêm “{{q}}” vào danh sách',
  alreadyExists: '“{{name}}” đã có — dùng mục này',
  failedStatus: 'Không thành công ({{status}})',
  chatScreenshot: '(ảnh chụp màn hình)',
  close: 'Đóng',
  couldNotSave: 'Không lưu được',
  // the Christmas season (season.js, 31/10)
  xmasMenu: "Giáng sinh",
  xmasOn: "Giao diện Giáng sinh",
  xmasSnow: "Hiệu ứng động (tuyết, đèn)",
  xmasNote: "Chỉ áp dụng cho bạn, trong mùa này. Hiệu ứng tự dừng nếu thiết bị của bạn bật giảm chuyển động.",
  xmasGreeting: "HEVN chúc bạn Giáng sinh an lành và Năm mới hạnh phúc!",
  xmasWish: "Chúc bạn và gia đình một mùa lễ ấm áp, bình an.",
  xmasHeroTitle: "Giáng sinh an lành!",
  xmasToday: "Giáng sinh vui vẻ — chính là hôm nay!",
  xmasNewYear: "Chúc mừng năm mới {{y}}!",
  xmasCountXmas: "Còn {{n}} ngày nữa là Giáng sinh",
  xmasCountNY: "Còn {{n}} ngày nữa là Năm mới",
  xmasTipTitle: "Giao diện Giáng sinh đang bật 🎄",
  xmasTipBody: "Bạn tắt được ở nút cây thông này, hoặc chỉ tắt tuyết và đèn. Bấm đĩa nhạc trên banner ở trang chủ để nghe nhạc Giáng sinh.",
  xmasTipOff: "Tắt giao diện Noel",
  xmasTipOk: "Đã hiểu",
  xmasMusicPlay: "Phát nhạc Giáng sinh",
  xmasMusicStop: "Dừng \"{{title}}\"",
  xmasOffAsk: "Không thích hiệu ứng? Tắt ngay tại đây, bật lại ở nút cây thông 🎄 trên cùng.",
  xmasMotionOff: "Tắt hiệu ứng",
  xmasMotionOn: "Bật hiệu ứng",
};

const zh = {
  styleHub: '款式中心',
  masterSheet: '主表',
  productLine: '产品线',
  capacity: '产能',
  sapShipDoc: 'SAP 出货单据',
  dailyOutput: '每日产量',
  toggleNav: '展开/收起导航',
  portalNav: '门户导航',
  closeNav: '关闭导航',
  testServer: '测试服务器 - 端口 3000，独立的构建和后端',
  roleSwitch: '以您的某个角色查看门户',
  all: '全部',
  searchIn: '搜索{{label}}',
  noMatches: '无匹配项',
  done: '完成',
  searchPh: '搜索…',
  clear: '清除',
  noMatchFor: '没有与“{{q}}”匹配的项',
  addToList: '+ 将“{{q}}”添加到列表',
  alreadyExists: '“{{name}}”已存在 — 使用它',
  failedStatus: '失败（{{status}}）',
  chatScreenshot: '（截图）',
  close: '关闭',
  couldNotSave: '无法保存',
  // the Christmas season (season.js, 31/10)
  xmasMenu: "圣诞节",
  xmasOn: "圣诞界面",
  xmasSnow: "动态效果（雪花、彩灯）",
  xmasNote: "仅对你本人、仅限本季生效。若设备开启了减少动态效果，效果会自动停止。",
  xmasGreeting: "HEVN 祝你圣诞快乐，新年幸福！",
  xmasWish: "祝你和家人度过一个温暖、平安的节日季。",
  xmasHeroTitle: "圣诞快乐！",
  xmasToday: "圣诞快乐——就在今天！",
  xmasNewYear: "{{y}} 新年快乐！",
  xmasCountXmas: "距圣诞节还有 {{n}} 天",
  xmasCountNY: "距新年还有 {{n}} 天",
  xmasTipTitle: "圣诞界面已开启 🎄",
  xmasTipBody: "可在此圣诞树按钮关闭，或只关闭雪花和彩灯。点击首页横幅上的唱片可播放圣诞歌曲。",
  xmasTipOff: "关闭圣诞界面",
  xmasTipOk: "知道了",
  xmasMusicPlay: "播放圣诞歌曲",
  xmasMusicStop: "停止“{{title}}”",
  xmasOffAsk: "不想要特效？可在这里关闭，点击顶部的 🎄 按钮可重新开启。",
  xmasMotionOff: "关闭特效",
  xmasMotionOn: "开启特效",
};

const dictionary = { ns: 'xShell', en, ko, vi, zh };

export default dictionary;
